import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat';
import * as webRTCActions from 'actions/chat/webrtc';
import WebRTC from 'components/chat/webrtc';

const cleanNulls = configuration => Object.keys(configuration)
  .filter(k => configuration[k] !== null)
  .reduce((obj, k) => {
    const prop = configuration[k];
    obj[k] = typeof prop === 'object' ? cleanNulls(prop) : prop;
    return obj;
  }, { });


export default connect(
  (state) => {
    const { webrtc } = state.chat,
      { clientConfiguration } = state.chat.main;

    return {
      loading: webrtc.loading,
      error: webrtc.error,
      mode: webrtc.mode,
      apiKey: webrtc.session && webrtc.session.apiKey,
      sessionId: webrtc.session && webrtc.session.sessionID,
      userToken: webrtc.session && webrtc.session.userToken,
      canPublishVideo: webrtc.canPublishVideo,
      mainVideoDisplay: clientConfiguration.mainVideoDisplay,
      devices: webrtc.devices.toArray(),
      audioEstablishingLabel: clientConfiguration.audioEstablishingLabel,
      audioEstablishedLabel: clientConfiguration.audioEstablishedLabel,
      webRTCSubscriberConfiguration: cleanNulls(clientConfiguration.webRTCSubscriberConfiguration),
      webRTCPublisherConfiguration: cleanNulls(clientConfiguration.webRTCPublisherConfiguration),
      preferedCamera: clientConfiguration.preferedCamera,
      chosenCamera: webrtc.chosenCamera,
      disableCameraSwitch: clientConfiguration.disableCameraSwitch
    };
  },
  dispatch => bindActionCreators({
    onClientError: webRTCActions.clientError
  }, dispatch),
  null,
  { withRef: true }
)(WebRTC);



// WEBPACK FOOTER //
// ./containers/chat/webrtc/index.js